import './Sort.scss';

import { ArrowsDownUp } from '@phosphor-icons/react';
import { ButtonV2 } from '@travelwin/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSortOptions } from '../../hooks/useSortOptions';
import MenuList from '../MenuList/MenuList';

const className = 'c-SortBy';

export type SortOption = ReturnType<typeof useSortOptions>[number]['value'];

export const Sort = ({
  onSortChange,
}: {
  onSortChange: (sortBy: string) => void;
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const SORT_OPTIONS = useSortOptions();

  const sortRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (sortRef.current && !sortRef.current.contains(event.target as Node)) {
      setShowFilters(false);
    }
  };

  useEffect(() => {
    if (showFilters) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilters]);

  return (
    <div className={className} ref={sortRef}>
      <SortButton
        isShown={showFilters}
        toggleShow={() => setShowFilters(!showFilters)}
      />
      {showFilters && (
        <MenuList
          items={SORT_OPTIONS}
          showList={showFilters}
          onItemClick={(item) => {
            onSortChange(item.value);
            setShowFilters(false);
          }}
        />
      )}
    </div>
  );
};

const SortButton = ({
  toggleShow,
}: {
  isShown: boolean;
  toggleShow: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <ButtonV2
      size={'small'}
      onClick={toggleShow}
      variant={'secondary'}
      icons={{ leading: <ArrowsDownUp size={24} /> }}
    >
      {t('filter.sort', 'Sort By')}
    </ButtonV2>
  );
};

export default Sort;
